module.exports = __webpack_public_path__ + "static/media/register-hero.8eddc9f2.png";